import { COLORS } from '@btime/constants'
import { capitalizeIfLower } from '@btime/helpers'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { HorizontalLine } from '../../components/shapes/Line'
import { SmallText, Text, Title } from '../../components/presentation/Text'
import { useIsPermalinkPage } from '../../utils/session/permalinkToken'
import DynamicPresentation from './DynamicPresentation'
import Gallery from '../../components/presentation/gallery/Gallery'
import NonComplianceTag from '../nonCompliances/NonComplianceTag'
import Panel from '../../components/structure/Panel'
import Plain from '../../packages/kiti/components/helpers/Plain'
import RecordId from '../../components/presentation/RecordId'
import Separator from '../../components/helpers/Separator'

const getBorderColor = reply => {
  const valueType = reply.question.type.name
  if (reply.isNonCompliance) {
    return COLORS.red
  }
  if (valueType === 'pending') {
    return COLORS.purple
  }
  return COLORS.dark5
}

const Wrapper = ({ children, noWrapper, borderColor }) => {
  if (noWrapper) return children

  return (
    <Panel lineBorder mediumPadding borderLeftColor={borderColor} noMargin>
      {children}
    </Panel>
  )
}

const DynamicPresentationCard = ({ reply, noWrapper, ValueWrapper, size }) => {
  ValueWrapper = ValueWrapper || Plain
  const borderColor = getBorderColor(reply)
  const isPublic = useIsPermalinkPage()

  const valueType = reply.question.type.name
  const hasNonCompliance = reply.isNonCompliance && !isPublic
  const notes = reply.notes
  const documents = reply.documents

  return (
    <Wrapper noWrapper={noWrapper} borderColor={borderColor}>
      <div>
        <Separator />
        <Grid align="center" justify="space-between">
          <Col>
            <RecordId labelPrefix="QUESTION_ID" record={reply.question} />
            <Title size={size || 'h6'} weight={600} noMargin>
              {capitalizeIfLower(reply.question.name)}
            </Title>
          </Col>
          {hasNonCompliance && (
            <Col widthOnSmall="100%">
              <NonComplianceTag reply={reply} />
            </Col>
          )}
        </Grid>

        <Separator weight={2} />
        <div>
          <ValueWrapper>
            <DynamicPresentation type={valueType} value={reply.value} {...(reply.question?.data || {})} />
          </ValueWrapper>
        </div>
      </div>

      {!!notes && (
        <div>
          <Separator weight={4} />
          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />
          <SmallText size="xsmall">Anotações</SmallText>
          <Separator />
          <Text>{notes}</Text>
        </div>
      )}

      {!!documents && !!documents.length && (
        <div>
          <Separator weight={4} />
          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />
          <SmallText size="xsmall">Fotos</SmallText>
          <Separator />
          <Gallery items={documents} />
        </div>
      )}
    </Wrapper>
  )
}

export default DynamicPresentationCard
